import React, { useContext } from 'react';
import styles from './SaveButton.styles';
import useSaveButtonHook from './SaveButton.hook';
import { AppContext } from '../../../App.context';
import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';
import AppButton from '../Forms/AppButton/AppButton';
import { Popconfirm } from 'antd';

export default function SaveButton({
  text,
  action,
  enableApplyToChain = true,
  enableAllHotels = false,
  showPopConfirm = true,
  disabled = false,
  hidden = false,
  ...props
}) {
  const { appState, appActions } = useContext(AppContext);
  const { state, actions } = useSaveButtonHook(enableAllHotels);
  if (hidden) return '';
  return appState?.hotelList && appState?.hotelList.length ? (
    <div style={styles.container}>
      <div style={styles.row}>
        {enableApplyToChain && (
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <CustomRadioButton
              value={!state.applyToAllHotels}
              text={appActions.translate('hotelSelector.onlyTo')}
              subtitle={actions.getSelectedHotelLabel()}
              onClick={() => actions.setApplyToCurrentHotel()}
              disabled={disabled}
            />
            <CustomRadioButton
              value={state.applyToAllHotels}
              text={appActions.translate('hotelSelector.applyToAllHotels')}
              onClick={() => actions.setApplyToAllHotels()}
              disabled={disabled}
            />
          </div>
        )}
      </div>
      <Popconfirm
        visible={state.showPopConfirm}
        title={appActions.translate('guestTable.applyToAllWarning')}
        onConfirm={() => {
          actions.setShowPopConfirm(false);
          action && action(state.applyToAllHotels);
        }}
        onCancel={() => actions.setShowPopConfirm(false)}
        okText={appActions.translate('ok')}
        cancelText={appActions.translate('cancel')}
        placement="topRight"
      >
        <AppButton
          text={text}
          action={action}
          setShowPopConfirm={showPopConfirm && actions.setShowPopConfirm}
          applyToAllHotels={state.applyToAllHotels}
          {...props}
          disabled={disabled}
        ></AppButton>
      </Popconfirm>
    </div>
  ) : null;
}
